@if (theme(); as theme) {
    <app-theme-form
        mode="edit"
        [initialName]="theme.name"
        [initialThemeConfig]="theme.themeConfig ?? null"
        [initialResponses]="theme.freeformConfig?.badgesConfig ?? null"
        [initialAiConfig]="theme.freeformConfig?.aiConfig ?? null"
        [isSubmitting]="submitting()"
        (formSubmit)="onSubmit($event)"
    ></app-theme-form>
} @else {
    <div class="loading"></div>
}
